// Initial variables
let map;
let locations = [];
const markers = [];
let selectedMarker = null;
let mapCircles = [];
let filteredLocations = [];
let defaultCoord = { lat: 33.947311305126846, lng: -117.4460405158503 };
let searchedCoord = { lat: 33.947311305126846, lng: -117.4460405158503 };
let searchRange = 25;
let isManualZoom = false;
let filterKeywords = new Set();

// Storefront API
const shopifyStoreDomain = 'ares-develop.myshopify.com';
const storefrontAccessToken = 'f9aca4ce50bcb74d223bd6b2954f9e36';
const apiVersion = '2025-01';
const endpoint = `https://${shopifyStoreDomain}/api/${apiVersion}/graphql.json`;

// DOM elements
const searchForm = document.getElementById('mechanic-map-search-form');
const currentLocationButton = document.getElementById(
	'current-location-button',
);
const addressInput = document.getElementById('search-address');
const addressResetButton = document.querySelector(
	'.address-input-container button',
);
const countryInput = document.getElementById('search-country');
const radiusInput = document.getElementById('search-radius');
const partnerList = document.getElementById('mechanic-list');
const gridContainer = document.querySelector('.mechanic-results');
const resultMessage = document.getElementById('result-message');
const serviceFilters = document.querySelectorAll('.service-filters');
const inputError = document.querySelector('.input-error-message');

countryInput.addEventListener('change', (event) => {
	addressInput.value = '';
	if (event.target.value === 'US') {
		addressInput.placeholder = 'Enter zip code or city and state';
	} else if (event.target.value === 'CA') {
		addressInput.placeholder = 'Enter postal code or city, province';
	}
});

addressInput.addEventListener('input', (event) => {
	if (event.target.value && addressResetButton) {
		addressResetButton.style.display = 'block';
	} else {
		addressResetButton.style.display = 'none';
	}
});

addressResetButton.addEventListener('click', (event) => {
	addressInput.value = '';
	addressResetButton.style.display = 'none';
});

// Radius input event listener
radiusInput.addEventListener('change', (event) => {
	searchRange = parseInt(event.target.value);
	console.log('Search range:', searchRange);
	isManualZoom = true;
	map.setZoom(getZoomLevel(searchRange));

	// Re-filter locations based on the new defaultCoord and search range
	filteredLocations = filterLocations(
		locations,
		defaultCoord,
		searchRange,
		filterKeywords,
	);

	AddFilterMarkers(filteredLocations);
});

// Search form event listener
searchForm.addEventListener('submit', async (event) => {
	event.preventDefault();

	inputError.innerHTML = '';
	inputError.style.opacity = 0;

	const formData = new FormData(searchForm);
	const address = formData.get('address');
	const country = formData.get('country');

	if (!address) {
		inputError.innerHTML =
			'<i class="uil uil-exclamation-circle"></i> Please enter a valid zip code or city and state';
		inputError.style.opacity = 1;
		setTimeout(() => {
			inputError.style.opacity = 0;
		}, 4000);
		return;
	}

	if (address) {
		const newPosition = await getGeocodeFromZip(address, country);
		defaultCoord = { lat: newPosition.lat, lng: newPosition.lng };
		searchedCoord = { lat: newPosition.lat, lng: newPosition.lng };
		map.setCenter(defaultCoord);
	}

	// if (city && state) {
	// 	const newPosition = await getGeocodeFromCityState(city, state, country);
	// 	defaultCoord = { lat: newPosition.lat, lng: newPosition.lng };
	// 	searchedCoord = { lat: newPosition.lat, lng: newPosition.lng };
	// 	map.setCenter(defaultCoord);
	// }

	// Re-filter locations based on the new defaultCoord and search range
	filteredLocations = filterLocations(
		locations,
		defaultCoord,
		searchRange,
		filterKeywords,
	);

	AddFilterMarkers(filteredLocations);
});

// Get current location
currentLocationButton.addEventListener('click', (event) => {
	// zipCodeInput.value = '';
	addressInput.value = '';
	// stateInput.value = '';

	if ('geolocation' in navigator) {
		navigator.geolocation.getCurrentPosition((position) => {
			defaultCoord = {
				lat: position.coords.latitude,
				lng: position.coords.longitude,
			};
			searchedCoord = {
				lat: position.coords.latitude,
				lng: position.coords.longitude,
			};

			console.log('Current location:', defaultCoord);

			// Re-filter locations based on the new defaultCoord and search range
			filteredLocations = filterLocations(
				locations,
				defaultCoord,
				searchRange,
				filterKeywords,
			);

			AddFilterMarkers(filteredLocations, (isUserLocation = true));
		});
	} else {
		console.error('Geolocation is not supported by this browser.');
	}
});

// partnenrList event listener
partnerList.addEventListener('click', async (event) => {
	const target = event.target.closest('.mechanic-list-item');

	if (!target) return;

	if (event.target.tagName === 'BUTTON') {
		const footerContent = target.querySelector('.footer-content');
		const button = target.querySelector('.view-details-button');
		footerContent.style.display =
			footerContent.style.display === 'block' ? 'none' : 'block';
		footerContent.style.height =
			footerContent.style.height === 'auto' ? '0' : 'auto';
		button.textContent =
			button.textContent === 'View Details' ? 'Hide Details' : 'View Details';
		return;
	}

	// Remove 'list-focused' class from all items
	document.querySelectorAll('.mechanic-list-item').forEach((item) => {
		item.classList.remove('list-focused');
	});

	// Add 'list-focused' class only if it's not already focused
	if (!target.classList.contains('list-focused')) {
		target.classList.add('list-focused');
	}

	const businessName = target
		.querySelector('.business-name')
		?.textContent.trim();
	const location = filteredLocations.find(
		(loc) => loc.business_name === businessName,
	);

	if (location) {
		clearCircles();

		// Reset the previously selected marker
		if (selectedMarker) {
			selectedMarker.content = undefined; // Reset to red pin
		}

		selectedMarker = markers.find(
			(marker) => marker.title === location.business_name,
		);

		if (selectedMarker) {
			const { PinElement } = await google.maps.importLibrary('marker');
			const selectedPin = new PinElement({
				background: '#1d4a77', // Blue pin
				borderColor: '#FFFFFF',
				glyphColor: '#FFFFFF',
				scale: 1.2,
			});
			selectedMarker.content = selectedPin.element;
		}

		// Adjust zoom and draw a circle if it's a mobile shop

		const currentRangeFromInput = Number(
			document.getElementById('search-radius').value,
		);

		if (location.mobile_radius) {
			addCircle(location);

			if (location.mobile_radius > currentRangeFromInput) {
				isManualZoom = true;

				map.setZoom(getZoomLevelForMobile(location.mobile_radius));
			}
		} else {
			isManualZoom = true;
			map.setZoom(getZoomLevel(currentRangeFromInput));
		}

		// map.setCenter(defaultCoord);
	}
});

// Service filter changes
serviceFilters.forEach((filter) => {
	filter.addEventListener('change', (event) => {
		const keyword = event.target.value;
		const vehicleCheckboxes = document.querySelectorAll('.vehicle-checkbox');

		if (event.target.classList.contains('vehicle-checkbox')) {
			// Clear all other radio buttons
			vehicleCheckboxes.forEach((checkbox) => {
				if (checkbox !== event.target) {
					checkbox.checked = false;
					filterKeywords.delete(checkbox.value);
				}
			});
		}

		// Add to set if checked, remove if unchecked
		if (event.target.checked) {
			filterKeywords.add(keyword);
		} else {
			filterKeywords.delete(keyword);
		}
		console.log('Filter keywords:', filterKeywords);

		// Re-filter locations based on new search range
		filteredLocations = filterLocations(
			locations,
			defaultCoord,
			searchRange,
			filterKeywords,
		);

		AddFilterMarkers(filteredLocations, false, false, true);
	});
});

// Initialize map & address autocomplete
document.addEventListener('DOMContentLoaded', async () => {
	await google.maps.importLibrary('places');
	initMap();
	initAutocomplete();
});

// Helper functions

function AddFilterMarkers(
	filteredLocations,
	isUserLocation = false,
	triggeredByIdle = false,
	triggeredByZoom = false,
) {
	clearMarkers();

	let index = 0;
	partnerList.innerHTML = '';
	resultMessage.innerHTML = '';

	// Add filter logic here A-Z, Z-A, Mobile, Discount, etc.
	// filteredLocations = locations.sort((a, b) => {
	// 	if (a.featured && !b.featured) return -1;
	// 	if (!a.featured && b.featured) return 1;
	// 	return 0;
	// });

	if (!filteredLocations || !Array.isArray(filteredLocations)) {
		console.error('filteredLocations is not an array', filteredLocations);
		return;
	}

	if (filteredLocations && filteredLocations.length > 0) {
		resultMessage.innerHTML = `<h2>Found ${
			filteredLocations ? filteredLocations.length : 0
		} shops within</h2>`;
		radiusInput.style.display = 'block';

		for (const location of filteredLocations) {
			addIndividualMarker(location, index);
			const distance = haversineDistance(location.position, searchedCoord);

			const searchParams = new URLSearchParams({
				api: 1,
				origin: `${searchedCoord.lat},${searchedCoord.lng}`,
				destination: `${location.position.lat},${location.position.lng}`,
			});

			const directionsUrl = `https://www.google.com/maps/dir/?${searchParams.toString()}`;
			let hoursOfOperation = [];
			let websiteUrl = '';
			const today = new Date().toLocaleString('en-US', { weekday: 'long' });

			if (location.hours_of_operation) {
				const pattern =
					/(\w+): (Closed|From \d{1,2}:\d{2} [AP]M To \d{1,2}:\d{2} [AP]M)/g;

				hoursOfOperation = Array.from(
					location.hours_of_operation.matchAll(pattern),
				).map(([, day, value]) => {
					if (value === 'Closed') {
						return { day, closed: true };
					}

					const [, from, fromPeriod, to, toPeriod] = value.match(
						/From (\d{1,2}:\d{2}) ([AP]M) To (\d{1,2}:\d{2}) ([AP]M)/,
					);
					return {
						day,
						from: `${from} ${fromPeriod}`,
						to: `${to} ${toPeriod}`,
					};
				});
			}

			if (location.website) {
				const hostname = new URL(location.website).hostname;
				websiteUrl = hostname.replace(/^www\./, '');
			}

			partnerList.innerHTML += `
				<div tabindex="0" class="mechanic-list-item" data-index="${index}">
					<div class="featured">
						${location.mobile_radius ? '<div class="featured-elements">Mobile</div>' : ''}
						${
							location.discount_rate && location.discount_rate > 0
								? `<div class="featured-elements">${location.discount_rate}% off</div>`
								: ``
						}
					</div>
					<h3 class="business-name">${location.business_name}</h3>
					${
						location.mobile_radius
							? ``
							: `<div class="address">${location.address}</div>`
					}
					<div class="location-info">
						<a href="${directionsUrl}" target="_blank" class="direction-link">
                        	<i class="uil uil-compass"></i> ${Math.round(
														distance,
													)} miles
                    	</a>
						<a href="tel:${location.phone_number}" class="phone-link">
							<i class="uil uil-phone"></i>
							${location.phone_number}
						</a>
						${
							location.website
								? `<a href="${location.website}" target="_blank" class="website-link">
							<i class="uil uil-globe"></i> Website
						</a>`
								: location.email
									? `<a href="mailto:${location.email}" class="email-link">
							<i class="uil uil-envelope-alt"></i> Email
						</a>`
									: ``
						}		
					</div>
					<div class="location-footer">
						<button class="view-details-button">View Details</button>
						<div class="footer-content">
							<hr>
							${
								location.website
									? `<div class="footer-elements"><a href="${location.website}" target="_blank" class="website-link">
								<i class="uil uil-globe"></i> ${websiteUrl}
							</a></div>`
									: ``
							}	
							${
								location.google_my_business_link
									? `<div class="footer-elements"><a href="${location.google_my_business_link}" target="_blank" class="website-link">
								<i class="uil uil-google"></i> Google my business
							</a></div>`
									: ``
							}
							${
								location.address
									? `<div class="footer-elements"><i class="uil uil-map-marker"></i> ${location.address}</div>`
									: ``
							}
							${
								hoursOfOperation.length > 0
									? `<h4 class="footer-elements"><i class="uil uil-clock"></i> Hours of Operation</h4>
										<ul class="hours-of-operation footer-elements">
											${hoursOfOperation
												.map((hours) => {
													const isToday =
														hours.day.toLowerCase() === today.toLowerCase();
													const liClass = isToday ? 'highlight-today' : '';
													if (hours.closed) {
														return `<li class="${liClass}"><span>${hours.day}</span>: Closed</li>`;
													}
													return `<li class="${liClass}"><span>${hours.day}</span>: ${hours.from} - ${hours.to}</li>`;
												})
												.join('')}	
										</ul>`
									: ''
							}
							
						</div>
					</div>
				</div>
				`;
			index++;
		}
	} else {
		// alert('No locations found for the provided zip code');

		gridContainer.style.gridTemplateColumns = '';
		resultMessage.innerHTML = `<h2>Found ${
			filteredLocations ? filteredLocations.length : 0
		} partner shops within</h2>`;
		radiusInput.style.display = 'block';
		partnerList.innerHTML += `<div class="no-results">No results found</div>`;
	}

	if (!triggeredByZoom) {
		if (isUserLocation === true && triggeredByIdle === false) {
			map.setCenter(defaultCoord);
		} else {
			if (filteredLocations.length > 0 && triggeredByIdle === false) {
				map.setCenter(calAverageCoord(filteredLocations));
			}
		}

		isManualZoom = true;
		map.setZoom(getZoomLevel(searchRange));
	}
}

// Add error handling for geocode API
async function getGeocodeFromZip(zipCode, country = 'US') {
	const { Geocoder } = await google.maps.importLibrary('geocoding');
	const geocoder = new Geocoder();

	try {
		const { results } = await geocoder.geocode({
			address: zipCode,
			region: country.toLowerCase(),
		});

		if (!results || results.length === 0) {
			console.log('No geocode results found for the zip code:', zipCode);
		}

		if (results.length > 0) {
			console.log('Geocode result:', results[0]);
			console.log('Geocode result lat:', results[0].geometry.location.lat());
			console.log('Geocode result lng:', results[0].geometry.location.lng());
			newCoord = {
				lat: results[0].geometry.location.lat(),
				lng: results[0].geometry.location.lng(),
			};
			// Change state for filter
			stateForFilter = results[0].address_components[3].short_name;
			console.log('stateForFilter:', stateForFilter);
			return newCoord;
		}
	} catch (error) {
		console.error('Error getting geocode from zip:', error);
		return null;
	}
}

async function getGeocodeFromCityState(city, state, country = 'US') {
	const { Geocoder } = await google.maps.importLibrary('geocoding');
	const geocoder = new Geocoder();

	try {
		const { results } = await geocoder.geocode({
			address: `${city}, ${state} ${country}`,
		});

		if (results && results.length > 0) {
			console.log('Geocode result lat:', results[0].geometry.location.lat());
			console.log('Geocode result lng:', results[0].geometry.location.lng());
			newCoord = {
				lat: results[0].geometry.location.lat(),
				lng: results[0].geometry.location.lng(),
			};
			console.log('New coord in getGeocodeFromCityState:', newCoord);
			// Change state for filter
			stateForFilter = state;
			console.log('stateForFilter in getGeocodeFromCityState:', stateForFilter);
			return newCoord;
		}
	} catch (error) {
		console.error('Error getting geocode from city and state:', error);
		return null;
	}
}

function clearMarkers() {
	if (!markers) return;
	markers.forEach((marker) => {
		marker.map = null;
	});
	markers.length = 0;
}

async function addIndividualMarker(location, index) {
	const { PinElement, AdvancedMarkerElement } =
		await google.maps.importLibrary('marker');

	const selectedPin = new PinElement({
		background: '#1d4a77', // Blue pin
		borderColor: '#FFFFFF',
		glyphColor: '#FFFFFF',
		scale: 1.2,
	});

	const marker = new AdvancedMarkerElement({
		map: map,
		position: location.position,
		title: location.business_name,
		gmpClickable: true,
	});
	markers.push(marker);

	marker.addEventListener('gmp-click', () => {
		clearCircles();
		// Reset the previous marker to default if it exists
		if (selectedMarker && selectedMarker !== marker) {
			selectedMarker.content = undefined; // Reset to red
		}

		// Set the new selected marker
		marker.content = selectedPin.element;
		selectedMarker = marker; // Update the selected marker reference

		Array.from(partnerList.children).forEach((item) =>
			item.classList.remove('list-focused'),
		);

		// if mobile_rauis is exist, draw a circle around the mobile shop
		const currentRangeFromInput = Number(
			document.getElementById('search-radius').value,
		);

		if (location.mobile_radius) {
			addCircle(location);

			if (location.mobile_radius > currentRangeFromInput) {
				isManualZoom = true;

				map.setZoom(getZoomLevelForMobile(location.mobile_radius));
			}
		} else {
			isManualZoom = true;
			map.setZoom(getZoomLevel(currentRangeFromInput));
		}

		const mechanicListItem = Array.from(partnerList.children).find((item) => {
			return (
				item.querySelector('.business-name')?.textContent.trim() ===
				location.business_name
			);
		});

		if (mechanicListItem) {
			mechanicListItem.classList.add('list-focused');

			const mechanicList = document.getElementById('mechanic-list');
			if (mechanicList) {
				mechanicList.scrollTo({
					top: mechanicListItem.offsetTop - mechanicList.offsetTop,
					behavior: 'smooth',
				});
			}
		}
	});
}

async function initMap() {
	const zoomLevel = getZoomLevel(searchRange);
	const { Map } = await google.maps.importLibrary('maps');
	let idleTimeout;
	let lastCenter = defaultCoord;
	let lastZoom = zoomLevel;

	// Get all locations

	locations = await getAllLocations();

	// console.log('Before filtering All locations in initMap:', locations);

	// filter locations by boundary
	filteredLocations = filterLocations(
		locations,
		defaultCoord,
		searchRange,
		filterKeywords,
	);
	console.log('Filtered locations in initMap:', filteredLocations);

	map = new Map(document.getElementById('mechanic-map'), {
		zoom: zoomLevel,
		center: defaultCoord,
		mapId: 'DEMO_MAP_ID', // Replace with your actual map ID
	});

	AddFilterMarkers(filteredLocations, false, true);

	// map.addListener('dragend', () => {
	// 	// Prevent unnecessary updates if the center hasn't changed significantly
	// 	const newCenter = map.getCenter().toJSON();
	// 	const distanceMoved = haversineDistance(lastCenter, newCenter);

	// 	if (distanceMoved < 0.2) {
	// 		// 0.1 mile threshold to avoid minor drift causing re-renders
	// 		return;
	// 	}

	// 	// -----------------------------------------
	// 	// DEBUG: boundary box for the defaultCoord

	// 	// const boundaryBox = getBoundaryBox(defaultCoord, searchRange);
	// 	// const bounds = {
	// 	// 	north: boundaryBox.maxLat,
	// 	// 	south: boundaryBox.minLat,
	// 	// 	east: boundaryBox.maxLng,
	// 	// 	west: boundaryBox.minLng,
	// 	// };

	// 	// // draw a rectangle around the defaultCoord
	// 	// const rectangle = new google.maps.Rectangle({
	// 	// 	strokeColor: '#FF0000',
	// 	// 	strokeOpacity: 0.8,
	// 	// 	strokeWeight: 2,
	// 	// 	fillColor: '#FF0000',
	// 	// 	fillOpacity: 0.35,
	// 	// 	map: map,
	// 	// 	bounds: bounds,
	// 	// });

	// 	// setTimeout(() => {
	// 	// 	rectangle.setMap(null);
	// 	// }, 2000);

	// 	// -----------------------------------------

	// 	lastCenter = newCenter; // Update last known center
	// 	clearTimeout(idleTimeout);

	// 	idleTimeout = setTimeout(() => {
	// 		clearCircles();

	// 		defaultCoord = newCenter; // Update the coordinate

	// 		// Re-filter locations based on the new defaultCoord and search range
	// 		filteredLocations = filterLocations(
	// 			locations,
	// 			defaultCoord,
	// 			searchRange,
	// 			filterKeywords
	// 		);

	// 		AddFilterMarkers(filteredLocations, false, true);
	// 	}, 200); // 200ms debounce delay
	// });

	// Filter based on zoom level change
	map.addListener('zoom_changed', () => {
		// Prevent unnecessary updates if the zoom hasn't changed
		if (isManualZoom) {
			isManualZoom = false;
			return;
		}

		const newZoom = map.getZoom();

		if (newZoom === lastZoom) return; // Avoid unnecessary updates

		lastZoom = newZoom; // Update last known zoom level

		// Update search range based on zoom level
		searchRange = calculateSearchRangeFromZoom(newZoom);
		console.log('Zoom changed, new search range:', searchRange);

		// Re-filter locations based on new search range
		filteredLocations = filterLocations(
			locations,
			defaultCoord,
			searchRange,
			filterKeywords,
		);

		console.log('Filtered locations after zoom change:', filteredLocations);
		AddFilterMarkers(filteredLocations, false, false, true);
	});

	console.log('All locations in initMap:', locations);
}

function initAutocomplete() {
	if (!addressInput) return;

	const autocomplete = new google.maps.places.Autocomplete(addressInput, {
		types: ['locality'],
		componentRestrictions: { country: ['us', 'ca'] },
	});

	autocomplete.addListener('place_changed', () => {
		const place = autocomplete.getPlace();

		if (!place.geometry || !place.geometry.location) {
			console.error('No place data for the input:', place);
			return;
		}

		defaultCoord = {
			lat: place.geometry.location.lat(),
			lng: place.geometry.location.lng(),
		};

		searchedCoord = {
			lat: place.geometry.location.lat(),
			lng: place.geometry.location.lng(),
		};

		map.setCenter(defaultCoord);

		// Re-filter locations based on the new defaultCoord and search range
		filteredLocations = filterLocations(
			locations,
			defaultCoord,
			searchRange,
			filterKeywords,
		);

		AddFilterMarkers(filteredLocations);
	});
}

function getZoomLevel(searchRange) {
	const mapElement = document.getElementById('mechanic-map');
	// const mapWidth = mapElement.getBoundingClientRect().width; // Get the actual rendered width

	searchRange = Number(searchRange);

	switch (searchRange) {
		case 5:
			return 12;
		case 10:
			return 11;
		case 25:
			return 10;
		case 50:
			return 9;
		case 100:
			return 8;
		default:
			return 10;
	}
}

function calculateSearchRangeFromZoom(zoomLevel) {
	switch (zoomLevel) {
		case 12:
			return 5;
		case 11:
			return 10;
		case 10:
			return 25;
		case 9:
			return 50;
		case 8:
			return 100;
		default:
			if (zoomLevel > 12) return 5;
			return 25;
	}
}

function getZoomLevelForMobile(range) {
	// Define zoom scale factors for different ranges
	if (range <= 5) return 12; // Very small range - High zoom
	if (range <= 10) return 11;
	if (range <= 20) return 10;
	if (range <= 50) return 9;
	if (range <= 100) return 8;
	return 7;
}

function calAverageCoord(locations) {
	const total = locations.length;
	const averageLat = locations.reduce(
		(acc, curr) => acc + curr.position.lat,
		0,
	);
	const averageLng = locations.reduce(
		(acc, curr) => acc + curr.position.lng,
		0,
	);

	return {
		lat: averageLat / total,
		lng: averageLng / total,
	};
}

// Util function to caluclate distance between two points
function toRadians(degrees) {
	return degrees * (Math.PI / 180);
}

function haversineDistance(coord1, coord2) {
	const R = 3963.1; // Earth's radius in miles

	const lat1 = toRadians(coord1.lat);
	const lon1 = toRadians(coord1.lng);
	const lat2 = toRadians(coord2.lat);
	const lon2 = toRadians(coord2.lng);

	const dLat = lat2 - lat1;
	const dLon = lon2 - lon1;

	const a =
		Math.sin(dLat / 2) * Math.sin(dLat / 2) +
		Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLon / 2) * Math.sin(dLon / 2);

	const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

	const distance = R * c; // Distance in miles
	return distance;
}

function isPartnerInRange(partnerCoord, userCoord = defaultCoord, maxDistance) {
	const distance = haversineDistance(partnerCoord, userCoord);
	return distance <= maxDistance;
}

function getBoundaryBox(coord, radiusMiles) {
	const milesPerDegreeLat = 69; // Approx miles per degree of latitude
	const adjustedRadius = radiusMiles; // No need for 1.5 multiplier unless intentional padding

	// Latitude change in degrees
	const latChange = adjustedRadius / milesPerDegreeLat;

	// Longitude change in degrees (adjusted for latitude)
	const milesPerDegreeLng = milesPerDegreeLat * Math.cos(toRadians(coord.lat));
	const lngChange = adjustedRadius / milesPerDegreeLng || 0.0001;

	return {
		minLat: coord.lat - latChange,
		maxLat: coord.lat + latChange,
		minLng: coord.lng - lngChange,
		maxLng: coord.lng + lngChange,
	};
}

function filterLocationsByBoundary(locations, defaultCoord, searchRange) {
	const boundaryBox = getBoundaryBox(defaultCoord, searchRange);

	const filteredLocations = locations.filter((location) => {
		// Calculate distance from the current map center
		const distanceFromCenter = haversineDistance(
			location.position,
			defaultCoord,
		);

		if (distanceFromCenter > location.mobile_radius) {
			return false;
		}

		// Mobile shop case: check if any part of the service radius intersects the boundary box
		if (location.mobile_radius !== undefined) {
			const center = location.position;
			const radiusMiles = location.mobile_radius;

			// Check if the center is inside the boundary box (for direct matches)
			const isCenterInside =
				center.lat >= boundaryBox.minLat &&
				center.lat <= boundaryBox.maxLat &&
				center.lng >= boundaryBox.minLng &&
				center.lng <= boundaryBox.maxLng;

			// If the center is inside, the mobile shop is definitely within range
			if (searchRange >= radiusMiles) {
				// Search range is bigger → Include the shop **if the center is inside**
				return isCenterInside;
			}

			// Otherwise, check if any part of the mobile shop’s circle intersects the boundary box
			const closestPointDistance = Math.min(
				haversineDistance({ lat: boundaryBox.minLat, lng: center.lng }, center),
				haversineDistance({ lat: boundaryBox.maxLat, lng: center.lng }, center),
				haversineDistance({ lat: center.lat, lng: boundaryBox.minLng }, center),
				haversineDistance({ lat: center.lat, lng: boundaryBox.maxLng }, center),
			);

			return closestPointDistance <= radiusMiles;
		}

		// Default fixed shop logic
		return (
			location.position.lat >= boundaryBox.minLat &&
			location.position.lat <= boundaryBox.maxLat &&
			location.position.lng >= boundaryBox.minLng &&
			location.position.lng <= boundaryBox.maxLng
		);
	});

	console.log(
		'Filtered locations in filterLocationsByBoundary:',
		filteredLocations,
	);

	return filteredLocations;
}

async function getAllLocations() {
	let hasNextPage = true;
	let cursor = null;
	const blogId = 'gid://shopify/Blog/113106124834';
	let allLocations = [];

	while (hasNextPage) {
		const query = `
			query GetArticles($blogId: ID!, $after: String) {
				blog(id: $blogId) {
					articles(first: 250, after: $after) {
					edges {
						node {
							id
							title
							metafields(identifiers: [
								{ namespace: "custom", key: "hours_of_operation" },
								{ namespace: "custom", key: "google_my_business_link" },
								{ namespace: "custom", key: "website" },
								{ namespace: "custom", key: "mobile_radius" },
								{ namespace: "custom", key: "vehicles" },
								{ namespace: "custom", key: "services" },
								{ namespace: "custom", key: "discount_rate" },								
								{ namespace: "custom", key: "position" },
								{ namespace: "custom", key: "address" },
								{ namespace: "custom", key: "phone_number" },
								{ namespace: "custom", key: "state" },
								{ namespace: "custom", key: "city" },
								{ namespace: "custom", key: "zip_code" },
								{ namespace: "custom", key: "business_name" },
								{ namespace: "custom", key: "email" },              
							]) {
							key
							value
							}
						}
					}
					pageInfo {
						hasNextPage
						endCursor
					}
					}
				}
				}
			`;

		const variables = cursor ? { blogId, after: cursor } : { blogId };

		try {
			const response = await fetch(endpoint, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
				},
				body: JSON.stringify({ query, variables }),
			});

			const result = await response.json();

			if (
				!result ||
				!result.data ||
				!result.data.blog ||
				!result.data.blog.articles ||
				result.errors
			) {
				console.error('GraphQL Errors:', result.errors);
				return [];
			}

			const locations = result?.data?.blog?.articles?.edges || [];

			// Extract locations from metafields and add them to allLocations
			locations.forEach((edge) => {
				const metafieldData = (edge.node.metafields || []).reduce(
					(acc, metafield) => {
						if (metafield?.key) {
							// Ensure metafield and key exist
							acc[metafield.key] = metafield.value;
						}
						return acc;
					},
					{},
				);

				// Parse "position" JSON field
				if (metafieldData.position) {
					try {
						metafieldData.position = JSON.parse(metafieldData.position);
					} catch (err) {
						console.error('Error parsing position JSON:', err);
					}
				}

				// Add processed location to the final list
				allLocations.push(metafieldData);
			});

			// Check if more pages exist and update cursor
			hasNextPage = result.data.blog.articles.pageInfo.hasNextPage;
			cursor = result.data.blog.articles.pageInfo.endCursor || null;
		} catch (error) {
			console.error('Error fetching articles:', error);
		}
	}
	return allLocations;
}

function filterLocations(locations, userCoord, searchRange, filterKeywords) {
	if (!Array.isArray(locations)) {
		console.error('Invalid locations data:', locations);
		return [];
	}
	return filterLocationsByBoundary(locations, userCoord, searchRange).filter(
		(location) => {
			if (filterKeywords.size === 0) return true;

			const services = location.services
				? location.services
						.split(',')
						.map((service) => service.trim().toLowerCase())
				: [];
			const vehicles = location.vehicles
				? location.vehicles
						.split(',')
						.map((vehicle) => vehicle.trim().toLowerCase())
				: [];

			const selectedVehicles = [...filterKeywords].filter((keyword) =>
				['domestic-gas', 'domestic-diesel', 'asian', 'european'].includes(
					keyword,
				),
			);
			const selectedServices = [...filterKeywords].filter(
				(keyword) => !selectedVehicles.includes(keyword),
			);

			// Check if the location matches a selected vehicle
			const hasMatchingVehicle =
				selectedVehicles.length === 0 ||
				selectedVehicles.some((vehicle) => vehicles.includes(vehicle));

			// Check if the location matches a selected service
			const hasMatchingService =
				selectedServices.length === 0 ||
				selectedServices.some((service) => services.includes(service));

			// If both vehicles & services are selected, BOTH must match
			if (selectedVehicles.length > 0 && selectedServices.length > 0) {
				return hasMatchingVehicle && hasMatchingService;
			}

			// If only vehicles are selected, at least one must match
			if (selectedVehicles.length > 0) {
				return hasMatchingVehicle;
			}

			// If only services are selected, at least one must match
			if (selectedServices.length > 0) {
				return hasMatchingService;
			}

			return false;
		},
	);
}

function clearCircles() {
	if (!mapCircles) return;
	mapCircles.forEach((circle) => {
		circle.setMap(null); // Remove from map
	});
	mapCircles.length = 0; // Empty the array
}

async function addCircle(location) {
	const { Circle } = await google.maps.importLibrary('geometry');

	const circle = new google.maps.Circle({
		strokeColor: '#0000FF',
		strokeOpacity: 0.7,
		strokeWeight: 2,
		fillColor: '#0000FF',
		fillOpacity: 0.2,
		map: map,
		center: location.position,
		radius: location.mobile_radius * 1609.34, // Convert miles to meters
	});

	mapCircles.push(circle); // Store the circle
}

// Non map util functions
// function filterBuilder(coverages) {
// 	return coverages
// 		.map(
// 			(coverage) => `(city='${coverage.city}' AND state='${coverage.state}')`
// 		)
// 		.join(' OR '); // Joins multiple conditions with " OR "
// }

// function urlBuilderForGeojson(coverages) {
// 	const baseUrl =
// 		'https://vps-dev.arestechnologies.com/api/v0/qcat/_table/jay_test/geojson';

// 	const queryParams = new URLSearchParams({
// 		cols: 'geojson',
// 		filter: filterBuilder(coverages),
// 	});

// 	return `${baseUrl}?${queryParams.toString()}`;
// }

// async function fetchGeojson(coverages) {
// 	const url = urlBuilderForGeojson(coverages);

// 	const response = await fetch(url, {
// 		method: 'GET',
// 		headers: {
// 			'x-api-key': 'B3y4trK0PISxQ/h6wSVa',
// 		},
// 	});
// 	const { data } = await response.json();

// 	return data;
// }

// This code is used for drawing a rectangle and circle around the defaultCoord
// // const boundaryBox = getBoundaryBox(defaultCoord, searchRange);
// const bounds = {
// 	north: boundaryBox.maxLat,
// 	south: boundaryBox.minLat,
// 	east: boundaryBox.maxLng,
// 	west: boundaryBox.minLng,
// };

// // draw a rectangle around the defaultCoord
// const rectangle = new google.maps.Rectangle({
// 	strokeColor: '#FF0000',
// 	strokeOpacity: 0.8,
// 	strokeWeight: 2,
// 	fillColor: '#FF0000',
// 	fillOpacity: 0.35,
// 	map: map,
// 	bounds: bounds,
// });

// // add a circle around the defaultCoord
// const circle = new google.maps.Circle({
// 	strokeColor: '#FF0000',
// 	strokeOpacity: 0.8,
// 	strokeWeight: 2,
// 	fillColor: '#FF0000',
// 	fillOpacity: 0.35,
// 	map: map,
// 	center: defaultCoord,
// 	radius: searchRange * 1609.34, // Convert miles to meters
// });

// const geojsons = await fetchGeojson(coverages);

// for (const geojson of geojsons) {
// 	map.data.addGeoJson(geojson.geojson);
// 	map.data.setStyle({
// 		fillColor: '#FF0000',
// 		strokeColor: '#FF0000',
// 		strokeWeight: 2,
// 		fillOpacity: 0.25,
// 	});
// }

// [ADVANCED VERSION]
// map.data.addGeoJson(testGeoJson);

// map.data.setStyle({
// 	fillColor: '#FF0000',
// 	strokeColor: '#FF0000',
// 	strokeWeight: 2,
// 	fillOpacity: 0.25,
// });

// Remove all features after 3 seconds
// setTimeout(() => {
// 	map.data.forEach((feature) => {
// 		map.data.remove(feature);
// 	});
// }, 5000);
